const SAVEDBY_HANDLE = 'savedby-package-protection';

const getFilteredCartItems = (items) => {
    if (!items?.length) return [];
    if (!items.some((item) => item.handle === SAVEDBY_HANDLE)) return items;
    return items.filter((item) => item.handle !== SAVEDBY_HANDLE);
};

const getPaidSubtotal = (items) => {
    return getFilteredCartItems(items).reduce((total, item) => {
        if (item.properties?.__free_sample || item.properties?.GWP) return total;
        return total + item.final_line_price;
    }, 0);
};

const shouldExcludeSample = (cartItems) => {
    const sampleItem = cartItems.find((item) => item.properties?.__free_sample);
    if (cartItems.length === 1 && cartItems[0].gift_card) return true;
    if (cartItems.length === 2 && cartItems.some((item) => item.gift_card) && sampleItem) return true;
    return false;
};

const getSampleThreshold = () => {
    const el = document.querySelector('free-sample, free-samples2');
    return el ? parseInt(el.dataset.threshold, 10) : 0;
};

const getCartSectionUpdater = () => (
    document.querySelector('cart-drawer-items') ||
    document.querySelector('cart-items') ||
    document.querySelector('cart-drawer')
);

const getCartSectionsForRequest = (updater) => {
    if (!updater?.getSectionsToRender) return [];
    return updater.getSectionsToRender().map((section) => section.section || section.id);
};

const renderCartSections = (updater, parsedState) => {
    if (!updater?.renderContents || !parsedState) return;
    updater.renderContents(parsedState);
};

const fetchCart = async () => {
    try {
        return await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
};

const handleSampleRecharge = () => {
    if (typeof reChargeCartJS !== 'function') return;

    let hasSubscriptions = false;
    document.querySelectorAll('.cart-item').forEach((item) => {
        if (item.dataset.isSubscription && JSON.parse(item.dataset.isSubscription)) {
            hasSubscriptions = true;
        }
    });
    window.ReCharge.cart_options.disable = !hasSubscriptions;
    reChargeCartJS();
};

const shouldRemoveSample = (sampleItem, subtotal, threshold, excludeSample) => {
    if (!sampleItem) return false;
    if (excludeSample || sampleItem.quantity > 1) return true;
    if (threshold > 0) return subtotal < threshold;
    return subtotal === 0;
};

const reconcileFreeSampleCart = async () => {
    const cartResponse = await fetchCart();
    if (!cartResponse) return;

    const cartItems = getFilteredCartItems(cartResponse.items);
    const sampleItem = cartItems.find((item) => item.properties?.__free_sample);
    const excludeSample = shouldExcludeSample(cartItems);
    const subtotal = getPaidSubtotal(cartResponse.items);
    const threshold = getSampleThreshold();
    const freeSampleEl = document.querySelector('free-sample');
    const sectionUpdater = getCartSectionUpdater();
    const sections = getCartSectionsForRequest(sectionUpdater);

    if (freeSampleEl?.select) {
        if (subtotal < threshold || excludeSample) {
            freeSampleEl.select.setAttribute('disabled', 'disabled');
        } else {
            freeSampleEl.select.removeAttribute('disabled');
        }
    }

    if (!sampleItem && subtotal >= threshold && !excludeSample && freeSampleEl) {
        const sku = freeSampleEl.getSku();
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: freeSampleEl.getVariantId(),
                    quantity: 1,
                    properties: {
                        __free_sample: freeSampleEl.getVariantId(),
                        __free_sample_version: 'S1',
                        __skus: `1x${sku}`,
                    },
                }],
                sections,
                sections_url: window.location.pathname,
            }),
        }).then((res) => res.json());

        renderCartSections(sectionUpdater, response);
        handleSampleRecharge();
        return;
    }

    if (!shouldRemoveSample(sampleItem, subtotal, threshold, excludeSample)) return;

    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: sampleItem.key,
            quantity: 0,
            sections,
            sections_url: window.location.pathname,
        }),
    }).then((res) => res.json());

    renderCartSections(sectionUpdater, response);
    handleSampleRecharge();
};

class FreeSample extends HTMLElement {

    static cartUpdateQueue = Promise.resolve();

    static enqueueCartUpdate(updateCart) {
        FreeSample.cartUpdateQueue = FreeSample.cartUpdateQueue.then(updateCart, updateCart);
        return FreeSample.cartUpdateQueue;
    }

    constructor() {
        super();

        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        console.log('reached here s1')
        this.select = this.querySelector('select');

        // document.addEventListener('DOMContentLoaded', this.initialize.bind(this))
        if (this.select) {
            this.select.addEventListener('change', this.onChange.bind(this))
        }
    }

    // Falls back to the element's own data attributes when there's no <select> to read from
    // (single-variant sample, nothing for the shopper to choose).
    getVariantId() {
        return this.select ? this.select.value : this.dataset.variantId;
    }

    getSku() {
        return this.select ? this.select.options[this.select.selectedIndex].dataset.sku : this.dataset.sku;
    }
    
    checkCookie() {
        if(document.querySelector('cart-drawer').classList.contains('sampling-s1')) {
            const samplingD = new Date();
            const samplingExDays = 356;
            samplingD.setTime(samplingD.getTime() + (samplingExDays*24*60*60*1000));
            document.cookie = "sampling_version=S1; expires=" + samplingD.toUTCString() + "; path=/";
        }
    
        let samplingVersion = this.getCookie("sampling_version");
        if (samplingVersion == 'S1') {
            window.ElevarDataLayer = window.ElevarDataLayer || [];
            window.ElevarDataLayer.push({ event: "dl_sampling", sampling_type: 'S1' });
            return true;
        } else {
            return false
        }
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    initialize() {

        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.onCartUpdate();
        });

        this.onCartUpdate()
    }
    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items' || event.source === 'product-form') return;
            FreeSample.reconcileActiveCart();
        });
    }
  
    disconnectedCallback() {
        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }
    onCartUpdate() {
        return FreeSample.enqueueCartUpdate(() => reconcileFreeSampleCart().catch((error) => {
            console.error('Error:', error);
        }));
    }

    static reconcileActiveCart() {
        const freeSampleEl = document.querySelector('free-sample');
        if (freeSampleEl) return freeSampleEl.onCartUpdate();
        return FreeSample.enqueueCartUpdate(() => reconcileFreeSampleCart().catch((error) => {
            console.error('Error:', error);
        }));
    }

    async reconcileCart() {
        return reconcileFreeSampleCart();
    }

    handleRecharge() {
        handleSampleRecharge();
    }

    onChange(event) {
        event.preventDefault()
        const variantId = this.select.value
        const sku = this.select.options[this.select.selectedIndex].dataset.sku
        const updateSample = () => this.replaceSample(variantId, sku).catch((error) => {
            console.error('Error:', error);
        });

        return FreeSample.enqueueCartUpdate(updateSample);
    }

    async replaceSample(variantId, sku) {
        const cartResponse = await fetchCart()
        if (!cartResponse || !this.isConnected) {
            return;
        }

        const sampleItem = cartResponse.items.find(item => item.properties?.__free_sample)
        if (sampleItem && String(sampleItem.variant_id) === String(variantId) && sampleItem.quantity === 1) {
            return;
        }

        const sectionUpdater = getCartSectionUpdater();
        const sections = getCartSectionsForRequest(sectionUpdater);

        if (sampleItem) {
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: sampleItem.key,
                    quantity: 0
                })
            }).then(response => response.json())
        }

        const latestCart = await fetchCart()
        if (!latestCart || latestCart.items.some(item => item.properties?.__free_sample)) {
            return;
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: {
                    '__free_sample': variantId,
                    '__free_sample_version': 'S1',
                    '__skus': `1x${sku}`,
                },
                sections,
                sections_url: window.location.pathname
            })
        }).then(response => response.json())

        renderCartSections(sectionUpdater, response);
        this.handleRecharge()
    }

    async getCart() {
        return fetchCart();
    }
}

customElements.define('free-sample', FreeSample);

class FreeSamples2 extends HTMLElement {
    
    constructor() {
        super();

        this.sampleRequestInFlight = false
        this.loadingOverlay = this.querySelector('.loading-overlay')
        this.removeSample = this.querySelector('a[data-remove-sample]')
        if(this.removeSample) {
            this.removeSample.addEventListener('click', this.removeSampleClick.bind(this))
        }

        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            if(this.dataset.active && (this.dataset.activeId == this.dataset.activeVariantId)) {
                FreeSample.reconcileActiveCart();
            }
            return;
        }

        document.addEventListener("swiper-loaded", this.initCartSwiper.bind(this))
        this.initCartSwiper()
        // this.onCartUpdate()


        if(this.dataset.active == 'false') {
            FreeSample.reconcileActiveCart();
            return;
        }

        this.selects = this.querySelectorAll('.select dl')
        if(this.selects.length > 0) {
            this.selects.forEach((dl)=>{
                dl.addEventListener('click', this.selectClick.bind(dl))
                dl.addEventListener('mouseleave', this.selectLeave.bind(dl))
            })
        }
        this.selectOptions = this.querySelectorAll('.select li')
        if(this.selectOptions.length > 0) {
            this.selectOptions.forEach((li)=>{
                li.addEventListener('click', this.selectOptionClick.bind(this))
            })
        }
        this.renderCartAttributes()
    }

    // initialize() {
    //     console.log('S2 init');
    //     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    //         this.onCartUpdate();
    //     });
    // }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items' || event.source === 'product-form') return;
            FreeSample.reconcileActiveCart();
        });
    }
  
    disconnectedCallback() {
        if(this.dataset.type == 'both' && !this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            return;
        }
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    showLoader() {
        this.loadingOverlay.classList.remove('hidden')
    }
    
    hideLoader() {
        this.loadingOverlay.classList.add('hidden')
    }

    renderCartAttributes() {
        // console.log('render');
        let formData = {
            attributes: {
                'S2': null,
                'S2: Sample': null,
                // 'S2: First Use': null,
                'S2: Category Hopper': null,
                'S2: Category': null,
                'S2: Sample Category': null,
                // 'S2: Count': null,
            }
        };
        if(this.dataset.activeId.length > 0) {
            formData = {
                attributes: {
                    'S2': true,
                    'S2: Sample': this.dataset.activeId,
                    // 'S2: First Use': this.dataset.firstUse == 'true',
                    'S2: Category Hopper': this.dataset.categoryHopper == 'true',
                    'S2: Category': this.dataset.category,
                    'S2: Sample Category': this.dataset.sampleCategory,
                    // 'S2: Count': this.dataset.s2Count,
                }
            }   
        }
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            console.log('Added cart attributes')
            console.log(formData)
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    onCartUpdate() {
        return FreeSample.reconcileActiveCart();
    }

    async removeSampleClick(event) {
        event.preventDefault();
        this.showLoader();
        await FreeSample.reconcileActiveCart();
        this.hideLoader();
    }

    async selectOptionClick(event) {
        event.preventDefault()
        event.stopPropagation();

        if(this.sampleRequestInFlight) {
            return;
        }

        this.sampleRequestInFlight = true
        this.showLoader()
        // console.log(event.target)

        event.target.closest('dl').classList.remove('active')

        const variantId = event.target.dataset.variantId
        const groupName = event.target.dataset.groupName
        const productGroupName = event.target.dataset.productGroupName
        const sectionUpdater = getCartSectionUpdater();
        const sections = getCartSectionsForRequest(sectionUpdater);
        const self = this

        const formData = {
            'items': [{
                'id': variantId,
                'quantity': 1,
                properties: {
                    '__free_sample': variantId,
                    '__free_sample_version': 'S2',
                    '__free_sample_group_name': groupName,
                    '__free_sample_product_group_name': productGroupName,
                }
            }],
            sections,
            'sections_url': window.location.pathname
        };
        const addSample = async () => {
            const cartResponse = await fetchCart()
            if (!cartResponse || !this.isConnected || cartResponse.items.some(item => item.properties?.__free_sample)) {
                return;
            }

            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            }).then(response => response.json())

            renderCartSections(sectionUpdater, response);
            self.handleRecharge()
        }

        try {
            await FreeSample.enqueueCartUpdate(addSample)
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.sampleRequestInFlight = false
            self.hideLoader()
        }
    }

    selectLeave(event) {
        this.classList.remove('active')
    }

    selectClick(event) {
        this.classList.toggle('active')
    }

    initCartSwiper() {
        if(typeof this.swiper == 'undefined' && typeof Swiper != 'undefined') {
            console.log(this.querySelectorAll('.swiper-slide').length)
            this.swiper = new Swiper(this.querySelector('.swiper'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                freeMode: false,
                slidesPerView: this.querySelectorAll('.swiper-slide').length > 1 ? 1.7 : 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                },
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    type: 'bullets',
                }
            })
        }
    }

    checkCookie() {
        let samplingVersion = this.getCookie("sampling_version");
        if (samplingVersion != 'S1') {
            window.ElevarDataLayer = window.ElevarDataLayer || [];
            window.ElevarDataLayer.push({ event: "dl_sampling", sampling_type: 'S2' });
            return true;
        } else {
            return false
        }
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    handleRecharge() {
        handleSampleRecharge();
    }

    async getCart() {
        return fetchCart();
    }
}

customElements.define('free-samples2', FreeSamples2);
